<template>
  <div id="pincode_page" v-loading="loading">
    <div class="formContainer flex-mid fc-FFFFFF">
      <div class="divContainer2">
        <div style="padding: 52px 160px 0 160px">
          <div class="center">
            <img
              src="../assets/images/navbar/logo_happily_dark.png"
              class="imgLogo p-11"
            />
          </div>
          <div class="fs-24 fw-900 mt-52">
            {{ $t('pincode.your_verification') }}
            <span class="fc-FBC02D">PIN code</span>
          </div>
          <div class="fs-16 mt-24">
            {{ $t('pincode.enter_the_four') }}
          </div>
          <el-form :model="ruleForm2" status-icon ref="ruleForm2" class="mt-12">
            <el-form-item prop="pincode" class="formItem">
              <div class="flex">
                <el-input
                  v-numericOnly
                  class="inputPincode"
                  ref="FirstInput"
                  maxlength="1"
                  type="text"
                  v-model="ruleForm2.pincode1"
                  @focus="onFirstInputFocus"
                  @keyup.native="onFirstInputChange"
                  auto-complete="off"
                ></el-input>
                <el-input
                  v-numericOnly
                  class="inputPincode"
                  ref="SecondInput"
                  style="margin-left: 16px"
                  maxlength="1"
                  type="text"
                  v-model="ruleForm2.pincode2"
                  @focus="onSecondInputFocus"
                  @keyup.native="onSecondInputChange"
                  auto-complete="off"
                ></el-input>
                <el-input
                  v-numericOnly
                  class="inputPincode"
                  ref="ThirdInput"
                  style="margin-left: 16px"
                  maxlength="1"
                  type="text"
                  v-model="ruleForm2.pincode3"
                  @focus="onThirdInputFocus"
                  @keyup.native="onThirdInputChange"
                  auto-complete="off"
                ></el-input>
                <el-input
                  v-numericOnly
                  class="inputPincode"
                  ref="ForthInput"
                  style="margin-left: 16px"
                  maxlength="1"
                  type="text"
                  v-model="ruleForm2.pincode4"
                  @focus="onForthInputFocus"
                  @keyup.native="onForthInputChange"
                  @keyup.enter.native="submitForm('ruleForm2')"
                  auto-complete="off"
                ></el-input>
              </div>
            </el-form-item>
            <div style="margin-top: 16px; display: none">
              <el-form-item prop="pass" class="formItem">
                <el-input
                  class="inputPincode"
                  style="margin-left: 8px"
                  type="password"
                  v-model="ruleForm2.passinput"
                  @keyup.enter.native="submitForm('ruleForm2')"
                  placeholder="password"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </div>
            <div style="margin-top: 42px">
              <el-form-item class="formItem">
                <el-button
                  class="btnSignIn"
                  type="primary"
                  @click="submitForm('ruleForm2')"
                  >{{ $t('global.submit') }}</el-button
                >
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div v-if="remaining < 3" class="warming-bottom fs-14 center">
          <div class="fw-700">{{ $t('pincode.your_code_is') }}</div>
          <div>({{ $t('pincode.you_have') }} {{ remaining }} {{ $t('pincode.attempts_remaining') }})</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "./../router";
import firebase from "firebase/app";
import "firebase/auth";
import Vue from "vue";
Vue.directive("numericOnly", {
  bind(el, binding, vnode) {
    el.addEventListener("keydown", (e) => {
      if ([8].indexOf(e.keyCode) !== -1) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if (
        (e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault();
      }
    });
  },
});
export default {
  created() {
    if (firebase.auth().currentUser && localStorage.getItem("userData")) {
      router.replace("/");
    }
    if (!this.$store.getters["authen/useremail"]) router.replace("/login");
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    error() {
      return this.$store.getters["authen/error"];
    },
    loading() {
      return this.$store.getters["authen/loading"];
    },
    useremail() {
      return this.$store.getters["authen/useremail"];
    },
  },
  watch: {
    error: function (val) {
      this.showError(val);
    },
    useremail: function (val) {
      this.checkUserEmail(val);
    },
  },
  data() {
    return {
      ruleForm2: {
        pincode1: "",
        pincode2: "",
        pincode3: "",
        pincode4: "",
        checked: true,
      },
      remaining: 3,
    };
  },
  mounted() {
    this.$refs.FirstInput.select();
  },
  methods: {
    checkUserEmail(val) {
      if (!val) router.replace("/login");
    },
    submitForm(formName) {
      this.auth();
    },
    auth() {
      this.$store.dispatch("authen/loginpincode", {
        pincode:
          this.ruleForm2.pincode1 +
          this.ruleForm2.pincode2 +
          this.ruleForm2.pincode3 +
          this.ruleForm2.pincode4,
      });
      setTimeout(() => {
        if (this.ruleForm2.pincode1 &&
          this.ruleForm2.pincode2 &&
          this.ruleForm2.pincode3 &&
          this.ruleForm2.pincode4) {
            this.ruleForm2.pincode1 = "";
            this.ruleForm2.pincode2 = "";
            this.ruleForm2.pincode3 = "";
            this.ruleForm2.pincode4 = "";
            this.$refs.FirstInput.select();
          }
      }, 1400)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    showError(message) {
      if (message) {
        this.remaining = this.remaining - 1;
      }

      if (message && this.remaining > 0) {
        this.$message({
          showClose: true,
          message,
          type: "error",
          duration: 4000,
        });
        setTimeout(() => {
          this.$store.dispatch("authen/clearError");
        }, 1000);
      } else if (this.remaining < 1) {
        this.$router.push("login");
      }
    },
    onFirstInputChange(e) {
      const re = /^[0-9\b]+$/;
      if (re.test(e.target.value)) {
        if (this.$refs.FirstInput.value) this.$refs.SecondInput.select();
      }
    },
    onSecondInputChange(e) {
      const re = /^[0-9\b]+$/;
      if (re.test(e.target.value)) {
        if (this.$refs.SecondInput.value) this.$refs.ThirdInput.select();
      } else {
        this.$refs.FirstInput.select();
      }
    },
    onThirdInputChange(e) {
      const re = /^[0-9\b]+$/;
      if (re.test(e.target.value)) {
        if (this.$refs.ThirdInput.value) this.$refs.ForthInput.select();
      } else {
        this.$refs.SecondInput.select();
      }
    },
    onForthInputChange(e) {
      const re = /^[0-9\b]+$/;
      if (re.test(e.target.value)) {
      } else {
        if (!this.$refs.ForthInput.value) this.$refs.ThirdInput.select();
      }
    },
    onFirstInputFocus() {
      if (this.$refs.FirstInput.value) this.$refs.FirstInput.select();
    },
    onSecondInputFocus() {
      if (this.$refs.SecondInput.value) this.$refs.SecondInput.select();
    },
    onThirdInputFocus() {
      if (this.$refs.ThirdInput.value) this.$refs.ThirdInput.select();
    },
    onForthInputFocus() {
      if (this.$refs.ForthInput.value) this.$refs.ForthInput.select();
    },
  },
};
</script>


<style lang="scss" scoped>
.input-email {
  height: 40px;
  font-size: 15px;
}
.formContainer {
  min-height: 100vh;
  height: calc(100vh);
  background-color: #6c30cc;
}
.divContainer2 {
  width: 640px;
  min-height: 600px;
  background: rgba($color: #111111, $alpha: 0.12);
  border-radius: 4px;
  transition: 0.3s;
  margin: auto;
}
.imgLogo {
  // width: 64px;
  height: 52px;
}
.formItem {
  width: 100%;
}
.btnSignIn {
  width: 100%;
  height: 50px;
  font-size: 20px;
  font-weight: 700;
  background-color: #32c2d5;
  &:hover {
    background-color: rgba($color: #32c2d5, $alpha: 0.9);
  }
}
a {
  color: #32c2d5;
  text-decoration: none;
}
.warming-bottom {
  transition: 0.2s;
  margin: 72px 60px 0 60px;
  padding: 24px 40px;
  border-radius: 4px;
  background-color: #f44336;
}
</style>

<style lang="scss">
#pincode_page {
  .el-input__inner {
    background-color: #00000099;
    color: #fff;
    border-width: 0;
  }
  .inputPincode.el-input {
    width: 64px;
    > input.el-input__inner {
      height: 64px;
      font-size: 28px;
      text-align: center;
      border: 1px solid #00000099;
      transition: 0.2s;
      &:focus {
        color: #fff;
        border-color: #32c2d5;
      }
    }
  }
}
</style>